// Bryntum Gantt locale - Spanish
const locale = {

    localeName : 'Es',
    localeDesc : 'Español',
    localeCode : 'es',

    Object : {
        Save : 'Guardar',
        Yes    : 'Sí',
        No     : 'No',
        Cancel : 'Cancelar',
        Ok     : 'OK',
        Week   : 'Semana',
        None   : 'Ninguno'
    },

    IgnoreResourceCalendarColumn : {
        'Ignore resource calendar' : 'Ignorar calendario de recursos'
    },

    InactiveColumn : {
        Inactive : 'Inactivo'
    },

    AddNewColumn : {
        'New Column' : 'Nueva columna'
    },

    BaselineStartDateColumn : {
        baselineStart : 'Inicio del Plan Base'
    },

    BaselineEndDateColumn : {
        baselineEnd : 'Finalización del Plan Base'
    },

    BaselineDurationColumn : {
        baselineDuration : 'Duración del Plan Base'
    },

    BaselineStartVarianceColumn : {
        startVariance : 'Desviación de inicio'
    },

    BaselineEndVarianceColumn : {
        endVariance : 'Desviación de finalización'
    },

    BaselineDurationVarianceColumn : {
        durationVariance : 'Variación de duración'
    },

    CalendarColumn : {
        Calendar : 'Calendario'
    },

    EarlyStartDateColumn : {
        'Early Start' : 'Inicio temprano'
    },

    EarlyEndDateColumn : {
        'Early End' : 'Fin temprano'
    },

    LateStartDateColumn : {
        'Late Start' : 'Inicio tardío'
    },

    LateEndDateColumn : {
        'Late End' : 'Fin tardío'
    },

    TotalSlackColumn : {
        'Total Slack' : 'Holgura total'
    },

    ConstraintDateColumn : {
        'Constraint Date' : 'Fecha de restricción'
    },

    ConstraintTypeColumn : {
        'Constraint Type' : 'Tipo de restricción'
    },

    DeadlineDateColumn : {
        Deadline : 'Fecha límite'
    },

    DependencyColumn : {
        'Invalid dependency' : 'Dependencia inválida'
    },

    DurationColumn : {
        Duration : 'Duración'
    },

    EffortColumn : {
        Effort : 'Esfuerzo'
    },

    EndDateColumn : {
        Finish : 'Fin'
    },

    ManuallyScheduledColumn : {
        'Manually scheduled' : 'Programado manualmente'
    },

    MilestoneColumn : {
        Milestone : 'Hito'
    },

    NameColumn : {
        Name : 'Nombre'
    },

    NoteColumn : {
        Note : 'Nota'
    },

    PercentDoneColumn : {
        '% Done' : '% completado'
    },

    PlannedPercentDoneColumn : {
        plannedPercentDone : '% Planificado completado'
    },

    PredecessorColumn : {
        Predecessors : 'Predecesores'
    },

    ResourceAssignmentColumn : {
        'Assigned Resources' : 'Recursos asignados',
        'more resources'     : 'más recursos'
    },

    RollupColumn : {
        Rollup : 'Resumen'
    },

    SchedulingModeColumn : {
        'Scheduling Mode' : 'Modo de programación'
    },

    SchedulingDirectionColumn : {
        schedulingDirection : 'Dirección de programación',
        inheritedFrom       : 'Heredado de',
        enforcedBy          : 'Impuesto por'
    },

    SequenceColumn : {
        Sequence : 'Secuencia'
    },

    ShowInTimelineColumn : {
        'Show in timeline' : 'Mostrar en la línea de tiempo'
    },

    StartDateColumn : {
        Start : 'Inicio'
    },

    SuccessorColumn : {
        Successors : 'Sucesores'
    },

    TaskCopyPaste : {
        copyTask  : 'Copiar',
        cutTask   : 'Cortar',
        pasteTask : 'Pegar'
    },

    WBSColumn : {
        WBS      : 'WBS',
        renumber : 'Renumerar'
    },

    DependencyField : {
        invalidDependencyFormat : 'Formato de dependencia inválido'
    },

    ProjectLines : {
        'Project Start' : 'Inicio del proyecto',
        'Project End'   : 'Fin del proyecto',
        statusDate      : 'Fecha de estado'
    },

    TaskTooltip : {
        Start    : 'Inicio',
        End      : 'Fin',
        Duration : 'Duración',
        Complete : 'Completado'
    },

    AssignmentGrid : {
        Name     : 'Nombre del recurso',
        Units    : 'Unidades',
        unitsTpl : ({ value }) => value ? value + '%' : ''
    },

    Gantt : {
        Edit                   : 'Editar',
        Indent                 : 'Aumentar sangría',
        Outdent                : 'Disminuir sangría',
        'Convert to milestone' : 'Convertir en hito',
        Add                    : 'Agregar...',
        'New task'             : 'Nueva tarea',
        'New milestone'        : 'Nuevo hito',
        'Task above'           : 'Tarea arriba',
        'Task below'           : 'Tarea abajo',
        'Delete task'          : 'Eliminar',
        Milestone              : 'Hito',
        'Sub-task'             : 'Subtarea',
        Successor              : 'Sucesor',
        Predecessor            : 'Predecesor',
        changeRejected         : 'El motor de programación rechazó los cambios',
        linkTasks              : 'Agregar dependencias',
        unlinkTasks            : 'Eliminar dependencias',
        color                  : 'Color'
    },

    EventSegments : {
        splitTask : 'Dividir tarea',
        splitEvent    : 'Dividir evento',
        renameSegment : 'Renombrar'
    },

    Indicators : {
        earlyDates   : 'Inicio/fin anticipado',
        lateDates    : 'Inicio/fin atrasado',
        Start        : 'Inicio',
        End          : 'Fin',
        deadlineDate : 'Fecha límite'
    },

    Versions : {
        indented     : 'Indentado',
        outdented    : 'Desindentado',
        cut          : 'Cortado',
        pasted       : 'Pegado',
        deletedTasks : 'Tareas eliminadas',
        entityNames : {
            TaskModel       : 'tarea',
            AssignmentModel : 'asignación',
            DependencyModel : 'enlace',
            ProjectModel    : 'proyecto',
            ResourceModel   : 'recurso',
            other           : 'objeto'
        },
        entityNamesPlural : {
            TaskModel       : 'tareas',
            AssignmentModel : 'asignaciones',
            DependencyModel : 'enlaces',
            ProjectModel    : 'proyectos',
            ResourceModel   : 'recursos',
            other           : 'objetos'
        },
        transactionDescriptions : {
            update : 'Modificadas {n} {entities}',
            add    : 'Agregadas {n} {entities}',
            remove : 'Eliminadas {n} {entities}',
            move   : 'Movidas {n} {entities}',
            mixed  : 'Modificadas {n} {entities}'
        },
        addEntity         : 'Se agregó {type} **{name}**',
        removeEntity      : 'Se eliminó {type} **{name}**',
        updateEntity      : 'Se modificó {type} **{name}**',
        moveEntity        : 'Se movió {type} **{name}** de {from} a {to}',
        addDependency     : 'Se agregó enlace de **{from}** a **{to}**',
        removeDependency  : 'Se eliminó enlace de **{from}** a **{to}**',
        updateDependency  : 'Se editó enlace de **{from}** a **{to}**',
        addAssignment     : 'Se asignó **{resource}** a **{event}**',
        removeAssignment  : 'Se eliminó la asignación de **{resource}** de **{event}**',
        updateAssignment  : 'Se editó la asignación de **{resource}** a **{event}**',
        noChanges         : 'Sin cambios',
        nullValue         : 'ninguno',
        versionDateFormat : 'M/D/YYYY h:mm a',
        undid             : 'Cambios deshechos',
        redid             : 'Cambios rehechos',
        editedTask        : 'Propiedades de tarea editadas',
        deletedTask       : 'Tarea eliminada',
        movedTask         : 'Tarea movida',
        movedTasks        : 'Tareas movidas'
    },

    ConstraintTypePicker : {
        none                : 'Ninguno',
        assoonaspossible    : 'Lo antes posible',
        aslateaspossible    : 'Lo más tarde posible',
        muststarton         : 'Debe iniciar el',
        mustfinishon        : 'Debe terminar el',
        startnoearlierthan  : 'Iniciar no antes de',
        startnolaterthan    : 'Iniciar no después de',
        finishnoearlierthan : 'Terminar no antes de',
        finishnolaterthan   : 'Terminar no después de'
    },

    SchedulingDirectionPicker : {
        Forward       : 'Hacia adelante',
        Backward      : 'Hacia atrás',
        inheritedFrom : 'Heredado de',
        enforcedBy    : 'Impuesto por'
    },

    CalendarField : {
        'Default calendar' : 'Calendario predeterminado',
        editCalendar       : 'Editar calendario'
    },

    TaskEditorBase : {
        Information   : 'Información',
        Save          : 'Guardar',
        Cancel        : 'Cancelar',
        Delete        : 'Eliminar',
        calculateMask : 'Calculando...',
        saveError     : 'No es posible guardar, corrija los errores primero',
        repeatingInfo : 'Visualizar un evento repetido',
        editRepeating : 'Editar'
    },

    TaskEdit : {
        editEvent              : 'Editar evento',
        ConfirmDeletionTitle   : 'Confirmar eliminación',
        ConfirmDeletionMessage : '¿Está seguro de que desea eliminar el evento?'
    },

    GanttTaskEditor : {
        editorWidth : '44em'
    },

    SchedulerTaskEditor : {
        editorWidth : '32em'
    },

    SchedulerGeneralTab : {
        labelWidth   : '6em',
        General      : 'General',
        Name         : 'Nombre',
        Resources    : 'Recursos',
        '% complete' : '% completado',
        Duration     : 'Duración',
        Start        : 'Inicio',
        Finish       : 'Fin',
        Effort       : 'Esfuerzo',
        Preamble     : 'Preámbulo',
        Postamble    : 'Conclusión'
    },

    GeneralTab : {
        labelWidth   : '6.5em',
        General      : 'General',
        Name         : 'Nombre',
        '% complete' : '% completado',
        Duration     : 'Duración',
        Start        : 'Inicio',
        Finish       : 'Fin',
        Effort       : 'Esfuerzo',
        Dates        : 'Fechas'
    },

    SchedulerAdvancedTab : {
        labelWidth                 : '13em',
        Advanced                   : 'Avanzado',
        Calendar                   : 'Calendario',
        'Scheduling mode'          : 'Modo de programación',
        'Effort driven'            : 'Impulsado por esfuerzo',
        'Manually scheduled'       : 'Programado manualmente',
        'Constraint type'          : 'Tipo de restricción',
        'Constraint date'          : 'Fecha de restricción',
        Inactive                   : 'Inactivo',
        'Ignore resource calendar' : 'Ignorar calendario de recursos'
    },

    CalendarEditorDatePicker : {
        addException : 'Añadir excepción',
        addWeek      : 'Añadir semana'
    },

    CalendarEditorExceptionTab : {
        addException    : 'Añadir excepción',
        removeException : 'Eliminar excepción',
        noRows          : 'No se agregaron excepciones'
    },

    CalendarEditorWeekTab : {
        addWeek    : 'Añadir semana',
        removeWeek : 'Eliminar semana'
    },

    CalendarEditor : {
        daysAreWorkingByDefault    : 'Los días funcionan por defecto',
        workingTimeCalendar        : 'Calendario de tiempo de trabajo',
        exceptions                 : 'Excepciones',
        general                    : 'En general',
        name                       : 'Nombre',
        parent                     : 'Padre',
        save                       : 'Guardar',
        weeks                      : 'Semanas',
        error                      : 'Error',
        inputErrors                : 'Hay errores de entrada. Corríjalos antes de guardar sus cambios.',
        delete                     : 'Eliminar',
        addCalendar                : 'Añadir un calendario',
        confirmation               : 'Confirmación',
        removeCalendarWithChildren : 'El calendario tiene subcalendarios. Presione "Sí" para eliminar el calendario con sus hijos.',
        removeCalendarAndLinks     : 'El calendario es usado por algunos registros. Presione "Sí" para desvincularlos y eliminar el calendario.'
    },

    CalendarEditorDateInfo : {
        isWorking    : 'está funcionando',
        isNotWorking : 'no está funcionando',
        basedOn      : 'basado en:',
        byDefault    : 'por defecto',
        rangeTpl     : (start, end) => `${start} - ${end}`
    },

    CalendarEditorLegend : {
        workingDay    : 'Día laborable',
        nonWorkingDay : 'Día no laborable'
    },

    AvailabilityRangeError : {
        errorOverlap       : 'Existen intervalos superpuestos',
        errorMissingDate   : 'Las horas de inicio y fin son obligatorias',
        errorStartAfterEnd : 'La hora de inicio no puede ser posterior a la hora de fin'
    },

    CalendarEditorExceptionPanel : {
        name                                 : 'Nombre',
        from                                 : 'De',
        to                                   : 'A',
        is                                   : 'Es',
        nonWorking                           : 'No laborable',
        working                              : 'Laborable',
        hours                                : 'Horas',
        repeat                               : 'Repetir',
        repeatEnd                            : 'Repetir fin',
        errorMissingDate                     : 'Se requiere el período de excepción',
        errorStartAfterEnd                   : 'La fecha "De" no puede ser posterior a la fecha "A"',
        errorStartAndEndRepeatNumberMismatch : 'La excepción debe comenzar y terminar el mismo número de veces'
    },

    CalendarEditorWeekPanel : {
        name        : 'Nombre',
        from        : 'De',
        to          : 'A',
        days        : 'Días',
        copyDay     : 'Copiar día',
        pasteDay    : 'Pegar día',
        stopCopying : 'Dejar de copiar'
    },

    CalendarEditorAvailabilityRangeContainer : {
        addRange    : 'Agregar intervalo',
        removeRange : 'Eliminar intervalo'
    },

    CalendarEditorWeekGrid : {
        errorStartAfterEnd           : 'La fecha "De" no puede ser posterior a la fecha "A"',
        errorNoDefaultWeek           : 'La configuración de la semana es obligatoria',
        errorMultipleDefaultWeeks    : 'Se especificó más de una semana predeterminada',
        errorNoWeekAvailability      : 'La semana debe proporcionar algún tiempo de trabajo',
        errorInvalidWeekAvailability : 'La semana tiene errores de configuración de tiempo de trabajo',
        noRows                       : 'No se ha añadido ninguna semana'
    },

    AdvancedTab : {
        labelWidth                 : '11.5em',
        Advanced                   : 'Avanzado',
        Calendar                   : 'Calendario',
        'Scheduling mode'          : 'Modo de programación',
        'Effort driven'            : 'Impulsado por esfuerzo',
        'Manually scheduled'       : 'Programado manualmente',
        'Constraint type'          : 'Tipo de restricción',
        'Constraint date'          : 'Fecha de restricción',
        Constraint                 : 'Restricción',
        Rollup                     : 'Resumen',
        Inactive                   : 'Inactivo',
        'Ignore resource calendar' : 'Ignorar calendario de recursos',
        'Scheduling direction'     : 'Dirección de programación',
        projectBorder              : 'Frontera del proyecto',
        ignore                     : 'Ignorar',
        honor                      : 'Respetar',
        askUser                    : 'Preguntar al usuario'
    },

    DependencyTab : {
        Predecessors      : 'Predecesores',
        Successors        : 'Sucesores',
        ID                : 'ID',
        Name              : 'Nombre',
        Type              : 'Tipo',
        Lag               : 'Retraso',
        cyclicDependency  : 'Dependencia cíclica',
        invalidDependency : 'Dependencia inválida'
    },

    NotesTab : {
        Notes : 'Notas'
    },

    ResourceCalendarColumn : {
        calendar : 'Calendario'
    },

    ResourcesTab : {
        unitsTpl  : ({ value }) => `${value}%`,
        Resources : 'Recursos',
        Resource  : 'Recurso',
        Units     : 'Unidades'
    },

    RecurrenceTab : {
        title : 'Repetir'
    },

    SchedulingModePicker : {
        Normal           : 'Normal',
        'Fixed Duration' : 'Duración fija',
        'Fixed Units'    : 'Unidades fijas',
        'Fixed Effort'   : 'Esfuerzo fijo'
    },

    ResourceHistogram : {
        barTipInRange         : '<b>{resource}</b> {startDate} - {endDate}<br><span class="{cls}">{allocated} de {available}</span> asignados',
        barTipOnDate          : '<b>{resource}</b> en {startDate}<br><span class="{cls}">{allocated} de {available}</span> asignados',
        groupBarTipAssignment : '<b>{resource}</b> - <span class="{cls}">{allocated} de {available}</span>',
        groupBarTipInRange    : '{startDate} - {endDate}<br><span class="{cls}">{allocated} de {available}</span> asignados:<br>{assignments}',
        groupBarTipOnDate     : 'En {startDate}<br><span class="{cls}">{allocated} de {available}</span> asignados:<br>{assignments}',
        plusMore              : '+{value} más'
    },

    ResourceUtilization : {
        barTipInRange         : '<b>{event}</b> {startDate} - {endDate}<br><span class="{cls}">{allocated}</span> asignados',
        barTipOnDate          : '<b>{event}</b> en {startDate}<br><span class="{cls}">{allocated}</span> asignados',
        groupBarTipAssignment : '<b>{event}</b> - <span class="{cls}">{allocated}</span>',
        groupBarTipInRange    : '{startDate} - {endDate}<br><span class="{cls}">{allocated} de {available}</span> asignados:<br>{assignments}',
        groupBarTipOnDate     : 'En {startDate}<br><span class="{cls}">{allocated} de {available}</span> asignados:<br>{assignments}',
        plusMore              : '+{value} más',
        nameColumnText        : 'Recurso/Evento'
    },

    SchedulingIssueResolutionPopup : {
        'Cancel changes'   : 'Cancelar el cambio y no hacer nada',
        schedulingConflict : 'Conflicto de programación',
        emptyCalendar      : 'Error de configuración del calendario',
        cycle              : 'Ciclo de programación',
        Apply              : 'Aplicar'
    },

    CycleResolutionPopup : {
        dependencyLabel        : 'Seleccione una dependencia:',
        invalidDependencyLabel : 'Hay dependencias inválidas que deben resolverse:'
    },

    DependencyEdit : {
        Active : 'Activo',
        From              : 'De',
        To                : 'A',
        Type              : 'Tipo',
        Lag               : 'Retraso',
        'Edit dependency' : 'Editar dependencia',
        Save              : 'Guardar',
        Delete            : 'Eliminar',
        Cancel            : 'Cancelar',
        StartToStart      : 'Inicio a Inicio',
        StartToEnd        : 'Inicio a Fin',
        EndToStart        : 'Fin a Inicio',
        EndToEnd          : 'Fin a Fin'
    },

    SchedulerProBase : {
        propagating     : 'Calculando el proyecto',
        storePopulation : 'Cargando datos',
        finalizing      : 'Finalizando resultados'
    },

    NestedEvents : {
        deNestingNotAllowed : 'No se permite la eliminación de anidamiento',
        nestingNotAllowed   : 'No se permite el anidamiento'
    },


    VersionGrid : {
        compare       : 'Comparar',
        description   : 'Descripción',
        occurredAt    : 'Ocurrió en',
        rename        : 'Renombrar',
        restore       : 'Restaurar',
        stopComparing : 'Detener comparación'
    },


    ResourceInfoColumn : {
        eventCountText : data => data + ' evento' + (data !== 1 ? 's' : '')
    },

    Dependencies : {
        from    : 'De',
        to      : 'A',
        valid   : 'Válido',
        invalid : 'Inválido'
    },

    DependencyType : {
        SS           : 'II',
        SF           : 'IF',
        FS           : 'FI',
        FF           : 'FF',
        StartToStart : 'Inicio a Inicio',
        StartToEnd   : 'Inicio a Fin',
        EndToStart   : 'Fin a Inicio',
        EndToEnd     : 'Fin a Fin',
        short        : [
            'II',
            'IF',
            'FI',
            'FF'
        ],
        long : [
            'Inicio a Inicio',
            'Inicio a Fin',
            'Fin a Inicio',
            'Fin a Fin'
        ]
    },


    EventEdit : {
        Name         : 'Nombre',
        Resource     : 'Recurso',
        Start        : 'Inicio',
        End          : 'Fin',
        Save         : 'Guardar',
        Delete       : 'Eliminar',
        Cancel       : 'Cancelar',
        'Edit event' : 'Editar evento',
        Repeat       : 'Repetir'
    },

    EventDrag : {
        eventOverlapsExisting : 'El evento se superpone con otro evento de este recurso',
        noDropOutsideTimeline : 'El evento no puede ubicarse completamente fuera de la cronología'
    },

    SchedulerBase : {
        'Add event'      : 'Agregar evento',
        'Delete event'   : 'Eliminar evento',
        'Unassign event' : 'Quitar asignación de evento',
        color            : 'Color'
    },

    TimeAxisHeaderMenu : {
        pickZoomLevel   : 'Nivel de zoom',
        activeDateRange : 'Rango de fechas',
        startText       : 'Fecha de inicio',
        endText         : 'Fecha de fin',
        todayText       : 'Hoy'
    },

    TimeAxisColumn : {
        ariaLabel : (startDate, endDate) => `Eje de tiempo mostrando ${startDate} hasta ${endDate}`
    },

    EventCopyPaste : {
        copyEvent  : 'Copiar evento',
        cutEvent   : 'Cortar evento',
        pasteEvent : 'Pegar evento'
    },

    EventFilter : {
        filterEvents : 'Filtrar tareas',
        byName       : 'Por nombre'
    },

    TimeRanges : {
        showCurrentTimeLine : 'Mostrar línea de tiempo actual'
    },

    PresetManager : {
        secondAndMinute : {
            displayDateFormat : 'll LTS',
            name              : 'Segundos'
        },
        minuteAndHour : {
            topDateFormat     : 'ddd DD/MM, H',
            displayDateFormat : 'll LST'
        },
        hourAndDay : {
            topDateFormat     : 'ddd DD/MM',
            middleDateFormat  : 'LST',
            displayDateFormat : 'll LST',
            name              : 'Día'
        },
        day : {
            name : 'Día/horas'
        },
        week : {
            name : 'Semana/horas'
        },
        dayAndWeek : {
            displayDateFormat : 'll LST',
            name              : 'Semana/días'
        },
        dayAndMonth : {
            name : 'Mes'
        },
        weekAndDay : {
            displayDateFormat : 'll LST',
            name              : 'Semana'
        },
        weekAndMonth : {
            name : 'Semanas'
        },
        weekAndDayLetter : {
            name : 'Semanas/días de la semana'
        },
        weekDateAndMonth : {
            name : 'Meses/semanas'
        },
        monthAndYear : {
            name : 'Meses'
        },
        year : {
            name : 'Años'
        },
        manyYears : {
            name : 'Varios años'
        }
    },

    RecurrenceConfirmationPopup : {
        'delete-title'              : 'Está eliminando un evento',
        'delete-all-message'        : '¿Desea eliminar todas las ocurrencias de este evento?',
        'delete-further-message'    : '¿Desea eliminar esta y todas las ocurrencias futuras de este evento o solo la ocurrencia seleccionada?',
        'delete-further-btn-text'   : 'Eliminar todos los eventos futuros',
        'delete-only-this-btn-text' : 'Eliminar solo este evento',
        'update-title'              : 'Está modificando un evento recurrente',
        'update-all-message'        : '¿Desea modificar todas las ocurrencias de este evento?',
        'update-further-message'    : '¿Desea modificar solo esta ocurrencia del evento o esta y todas las ocurrencias futuras?',
        'update-further-btn-text'   : 'Todos los eventos futuros',
        'update-only-this-btn-text' : 'Solo este evento',
        Yes                         : 'Sí',
        Cancel                      : 'Cancelar',
        width                       : 600
    },

    RecurrenceLegend : {
        ' and '                         : ' y ',
        Daily                           : 'Diariamente',
        'Weekly on {1}'                 : ({ days }) => `Semanalmente en ${days}`,
        'Monthly on {1}'                : ({ days }) => `Mensualmente en ${days}`,
        'Yearly on {1} of {2}'          : ({ days, months }) => `Anualmente el ${days} de ${months}`,
        'Every {0} days'                : ({ interval }) => `Cada ${interval} días`,
        'Every {0} weeks on {1}'        : ({ interval, days }) => `Cada ${interval} semanas en ${days}`,
        'Every {0} months on {1}'       : ({ interval, days }) => `Cada ${interval} meses en ${days}`,
        'Every {0} years on {1} of {2}' : ({ interval, days, months }) => `Cada ${interval} años el ${days} de ${months}`,
        position1                       : 'el primero',
        position2                       : 'el segundo',
        position3                       : 'el tercero',
        position4                       : 'el cuarto',
        position5                       : 'el quinto',
        'position-1'                    : 'el último',
        day                             : 'día',
        weekday                         : 'día de la semana',
        'weekend day'                   : 'día de fin de semana',
        daysFormat                      : ({ position, days }) => `${position} ${days}`
    },

    RecurrenceEditor : {
        'Repeat event'      : 'Repetir evento',
        Cancel              : 'Cancelar',
        Save                : 'Guardar',
        Frequency           : 'Frecuencia',
        Every               : 'Cada',
        DAILYintervalUnit   : 'día(s)',
        WEEKLYintervalUnit  : 'semana(s)',
        MONTHLYintervalUnit : 'mes(es)',
        YEARLYintervalUnit  : 'año(s)',
        Each                : 'Cada',
        on                  : 'En',
        the                 : 'El',
        'On the'            : 'El',
        'End repeat'        : 'Fin de repetición',
        'time(s)'           : 'vez/veces',
        Days                : 'Días',
        Months              : 'Meses'
    },

    RecurrenceDaysCombo : {
        day           : 'día',
        weekday       : 'día de la semana',
        'weekend day' : 'día de fin de semana'
    },

    RecurrencePositionsCombo : {
        position1    : 'primero',
        position2    : 'segundo',
        position3    : 'tercero',
        position4    : 'cuarto',
        position5    : 'quinto',
        'position-1' : 'último'
    },

    RecurrenceStopConditionCombo : {
        Never     : 'Nunca',
        After     : 'Después',
        'On date' : 'En la fecha'
    },

    RecurrenceFrequencyCombo : {
        None    : 'Sin repetición',
        Daily   : 'Diariamente',
        Weekly  : 'Semanalmente',
        Monthly : 'Mensualmente',
        Yearly  : 'Anualmente'
    },

    RecurrenceCombo : {
        None   : 'Ninguno',
        Custom : 'Personalizar'
    },

    Summary : {
        'Summary for' : date => `Resumen de ${date}`
    },

    ScheduleRangeCombo : {
        completeview : 'Programación completa',
        currentview  : 'Programación visible',
        daterange    : 'Rango de fechas',
        completedata : 'Programación completa (para todos los eventos)'
    },

    SchedulerExportDialog : {
        'Schedule range' : 'Rango de programación',
        'Export from'    : 'De',
        'Export to'      : 'Hasta'
    },

    ExcelExporter : {
        'No resource assigned' : 'Ningún recurso asignado'
    },

    CrudManagerView : {
        serverResponseLabel : 'Respuesta del servidor:'
    },


    RemoveDependencyCycleEffectResolution : {
        descriptionTpl : 'Eliminar dependencia'
    },
    DeactivateDependencyCycleEffectResolution : {
        descriptionTpl : 'Desactivar dependencia'
    },
    CycleEffectDescription : {
        descriptionTpl : 'Se encontró un ciclo, formado por: {0}'
    },
    EmptyCalendarEffectDescription : {
        descriptionTpl              : 'El calendario "{0}" no proporciona ningún intervalo de tiempo de trabajo.',
        forwardDescriptionTpl       : 'La tarea "{2}" no puede programarse. El calendario "{0}" no tiene horario de trabajo después de {1}.',
        backwardDescriptionTpl      : 'La tarea "{2}" no puede programarse. El calendario "{0}" no tiene horario de trabajo antes de {1}.',
        noIntersectionDescriptionTpl : 'La tarea "{2}" no puede programarse. Su calendario "{0}" y los calendarios de recursos no tienen tiempo de trabajo común.'
    },
    Use24hrsEmptyCalendarEffectResolution : {
        descriptionTpl : 'Use el calendario de 24 horas con sábados y domingos no laborables.'
    },
    Use8hrsEmptyCalendarEffectResolution : {
        descriptionTpl : 'Use el calendario de 8 horas (08:00-12:00, 13:00-17:00) con sábados y domingos no laborables.'
    },
    IgnoreProjectConstraintResolution : {
        descriptionTpl : 'Ignorar la frontera del proyecto y continuar con el cambio.'
    },
    ProjectConstraintConflictEffectDescription : {
        startDescriptionTpl : 'Ha movido la tarea "{0}" para iniciar el {1}, que es antes de la fecha de inicio del proyecto {2}.',
        endDescriptionTpl   : 'Ha movido la tarea "{0}" para finalizar el {1}, que es después de la fecha de fin del proyecto {2}.'
    },
    HonorProjectConstraintResolution : {
        descriptionTpl : 'Ajustar la tarea para respetar la frontera del proyecto.'
    },
    IgnoreResourceCalendarEmptyCalendarEffectResolution : {
        descriptionTpl : 'Ignorar los calendarios de recursos y programar la tarea usando únicamente su propio calendario.'
    },
    ConflictEffectDescription : {
        descriptionTpl : 'Se encontró un conflicto de programación: {0} entra en conflicto con {1}'
    },
    ConstraintIntervalDescription : {
        dateFormat : 'LLL'
    },
    ProjectConstraintIntervalDescription : {
        startDateDescriptionTpl : 'Fecha de inicio del proyecto {0}',
        endDateDescriptionTpl   : 'Fecha de fin del proyecto {0}'
    },
    ManuallyScheduledParentConstraintIntervalDescription : {
        startDescriptionTpl : 'La programación manual "{2}" obliga a sus subtareas a no comenzar antes de {0}',
        endDescriptionTpl   : 'La programación manual "{2}" obliga a sus subtareas a terminar como máximo el {1}'
    },
    DisableManuallyScheduledConflictResolution : {
        descriptionTpl : 'Desactivar programación manual para "{0}"'
    },
    DependencyConstraintIntervalDescription : {
        descriptionTpl : 'Dependencia ({2}) de "{3}" a "{4}"'
    },
    RemoveDependencyResolution : {
        descriptionTpl : 'Eliminar dependencia de "{1}" a "{2}"'
    },
    DeactivateDependencyResolution : {
        descriptionTpl : 'Desactivar dependencia de "{1}" a "{2}"'
    },
    DateConstraintIntervalDescription : {
        startDateDescriptionTpl : 'Restricciones {3} {0} de la tarea "{2}"',
        endDateDescriptionTpl   : 'Restricciones {3} {1} de la tarea "{2}"',
        constraintTypeTpl : {
            startnoearlierthan  : 'Iniciar no antes de',
            finishnoearlierthan : 'Terminar no antes de',
            muststarton         : 'Debe iniciar el',
            mustfinishon        : 'Debe terminar el',
            startnolaterthan    : 'Iniciar no después de',
            finishnolaterthan   : 'Terminar no después de'
        }
    },
    RemoveDateConstraintConflictResolution : {
        descriptionTpl : 'Eliminar la restricción "{1}" de la tarea "{0}"'
    },

    ColumnPicker : {
        column          : 'Columna',
        columnsMenu     : 'Columnas',
        hideColumn      : 'Ocultar columnas',
        hideColumnShort : 'Ocultar',
        newColumns      : 'Nuevas columnas'
    },

    Filter : {
        applyFilter   : 'Aplicar filtro',
        filter        : 'Filtro',
        editFilter    : 'Editar filtro',
        on            : 'en',
        before        : 'Antes',
        after         : 'Después',
        equals        : 'Igual a',
        lessThan      : 'Menor que',
        moreThan      : 'Mayor que',
        removeFilter  : 'Eliminar filtro',
        disableFilter : 'Desactivar filtro'
    },

    FilterBar : {
        enableFilterBar  : 'Mostrar barra de filtro',
        disableFilterBar : 'Ocultar barra de filtro'
    },

    Group : {
        group                : 'Agrupar',
        groupAscending       : 'Agrupar en orden ascendente',
        groupDescending      : 'Agrupar en orden descendente',
        groupAscendingShort  : 'Ascendente',
        groupDescendingShort : 'Descendente',
        stopGrouping         : 'Dejar de agrupar',
        stopGroupingShort    : 'Detener'
    },

    HeaderMenu : {
        moveBefore     : text => `Mover antes de "${text}"`,
        moveAfter      : text => `Mover después de "${text}"`,
        collapseColumn : 'Minimizar columna',
        expandColumn   : 'Ampliar columna'
    },

    ColumnRename : {
        rename : 'Renombrar'
    },

    MergeCells : {
        mergeCells  : 'Unir celdas',
        menuTooltip : 'Unir celdas con el mismo valor cuando estén ordenadas por esta columna'
    },

    Search : {
        searchForValue : 'Buscar valor'
    },

    Sort : {
        sort                   : 'Ordenar',
        sortAscending          : 'Ordenar ascendente',
        sortDescending         : 'Ordenar descendente',
        multiSort              : 'Ordenación múltiple',
        removeSorter           : 'Eliminar ordenación',
        addSortAscending       : 'Agregar orden ascendente',
        addSortDescending      : 'Agregar orden descendente',
        toggleSortAscending    : 'Cambiar a ascendente',
        toggleSortDescending   : 'Cambiar a descendente',
        sortAscendingShort     : 'Ascendente',
        sortDescendingShort    : 'Descendente',
        removeSorterShort      : 'Eliminar',
        addSortAscendingShort  : '+ Asc',
        addSortDescendingShort : '+ Desc'
    },

    Split : {
        split        : 'Dividido',
        unsplit      : 'Sin dividir',
        horizontally : 'Horizontalmente',
        vertically   : 'Verticalmente',
        both         : 'Ambos'
    },

    LockRows : {
        lockRow   : 'Bloquear fila',
        unlockRow : 'Desbloquear fila'
    },

    Column : {
        columnLabel : column => `${column.text ? `Columna ${column.text}. ` : ''}ESPACIO para menú contextual${column.sortable ? ', ENTER para ordenar' : ''}`,
        cellLabel   : new String()
    },

    Checkbox : {
        toggleRowSelect : 'Alternar selección de fila',
        toggleSelection : 'Alternar selección de todo el conjunto de datos'
    },

    RatingColumn : {
        cellLabel : column => {
            const rating = column.location?.record?.get(column.field) || 0;
            return `${column.text ? column.text : ''} valoración ${rating}`;
        }
    },

    GridBase : {
        loadFailedMessage  : '¡La carga de datos falló!',
        syncFailedMessage  : '¡La sincronización de datos falló!',
        unspecifiedFailure : 'Fallo no especificado',
        networkFailure     : 'Error de red',
        parseFailure       : 'Error al analizar la respuesta del servidor',
        serverResponse     : 'Respuesta del servidor:',
        noRows             : 'No hay registros para mostrar',
        moveColumnLeft     : 'Mover a la sección izquierda',
        moveColumnRight    : 'Mover a la sección derecha',
        moveColumnTo       : region => `Mover columna a ${region}`,
        loadMask : 'Cargando...',
        syncMask : 'Guardando cambios, espere...'
    },

    CellMenu : {
        removeRow : 'Eliminar'
    },

    RowCopyPaste : {
        copyRecord  : 'Copiar',
        cutRecord   : 'Cortar',
        pasteRecord : 'Pegar',
        rows        : 'filas',
        row         : 'fila'
    },

    CellCopyPaste : {
        copy  : 'Copiar',
        cut   : 'Cortar',
        paste : 'Pegar'
    },

    PdfExport : {
        'Waiting for response from server' : 'Esperando respuesta del servidor...',
        'Export failed'                    : 'Fallo en la exportación',
        'Server error'                     : 'Error de servidor',
        'Generating pages'                 : 'Generando páginas...',
        'Click to abort'                   : 'Cancelar'
    },

    ExportDialog : {
        width          : '40em',
        labelWidth     : '12em',
        exportSettings : 'Configuración de exportación',
        export         : 'Exportar',
        printSettings  : 'Configuración de impresión',
        print          : 'Imprimir',
        exporterType   : 'Control de paginación',
        cancel         : 'Cancelar',
        fileFormat     : 'Formato de archivo',
        rows           : 'Filas',
        alignRows      : 'Alinear filas',
        columns        : 'Columnas',
        paperFormat    : 'Formato de papel',
        orientation    : 'Orientación',
        repeatHeader   : 'Repetir encabezado'
    },

    ExportRowsCombo : {
        all     : 'Todas las filas',
        visible : 'Filas visibles'
    },

    ExportOrientationCombo : {
        portrait  : 'Vertical',
        landscape : 'Horizontal'
    },

    SinglePageExporter : {
        singlepage : 'Una página'
    },

    MultiPageExporter : {
        multipage     : 'Varias páginas',
        exportingPage : ({ currentPage, totalPages }) => `Exportando página ${currentPage}/${totalPages}`
    },

    MultiPageVerticalExporter : {
        multipagevertical : 'Varias páginas (vertical)',
        exportingPage     : ({ currentPage, totalPages }) => `Exportando página ${currentPage}/${totalPages}`
    },

    RowExpander : {
        loading  : 'Cargando',
        expand   : 'Expandir',
        collapse : 'Cerrar'
    },

    TreeGroup : {
        group                  : 'Agrupar por',
        stopGrouping           : 'Dejar de agrupar',
        stopGroupingThisColumn : 'Quitar agrupación de esta columna'
    },


    ColorPicker : {
        noColor : 'Sin color'
    },

    Combo : {
        noResults          : 'Sin resultados',
        recordNotCommitted : 'No se pudo agregar el registro',
        addNewValue        : value => `Agregar ${value}`
    },

    FilePicker : {
        file : 'Archivo'
    },

    Field : {
        badInput              : 'Valor de campo inválido',
        patternMismatch       : 'El valor debe coincidir con un patrón específico',
        rangeOverflow         : value => `El valor debe ser menor o igual a ${value.max}`,
        rangeUnderflow        : value => `El valor debe ser mayor o igual a ${value.min}`,
        stepMismatch          : 'El valor debe coincidir con el paso',
        tooLong               : 'El valor debe ser más corto',
        tooShort              : 'El valor debe ser más largo',
        typeMismatch          : 'El valor debe estar en un formato especial',
        valueMissing          : 'Este campo es obligatorio',
        invalidValue          : 'Valor de campo inválido',
        minimumValueViolation : 'Valor por debajo del mínimo',
        maximumValueViolation : 'Valor por encima del máximo',
        fieldRequired         : 'Este campo es obligatorio',
        validateFilter        : 'El valor debe seleccionarse de la lista'
    },

    DateField : {
        invalidDate : format => 'Fecha inválida, el formato esperado es ' + format
    },

    DatePicker : {
        gotoPrevYear  : 'Ir al año anterior',
        gotoPrevMonth : 'Ir al mes anterior',
        gotoNextMonth : 'Ir al mes siguiente',
        gotoNextYear  : 'Ir al año siguiente'
    },

    NumberFormat : {
        locale   : 'es',
        currency : 'EUR'
    },

    DurationField : {
        invalidUnit : 'Unidad inválida'
    },

    TimeField : {
        invalidTime : 'Hora inválida'
    },

    TimePicker : {
        hour   : 'Hora',
        minute : 'Minuto',
        second : 'Segundo'
    },

    List : {
        loading   : 'Cargando...',
        selectAll : 'Seleccionar todo'
    },


    PagingToolbar : {
        firstPage         : 'Ir a la primera página',
        prevPage          : 'Ir a la página anterior',
        page              : 'Página',
        nextPage          : 'Ir a la página siguiente',
        lastPage          : 'Ir a la última página',
        reload            : 'Recargar la página actual',
        noRecords         : 'Sin registros',
        pageCountTemplate : data => `de ${data.lastPage}`,
        summaryTemplate   : data => `Mostrando registros ${data.start} - ${data.end} de ${data.allCount}`
    },

    PanelCollapser : {
        Collapse : 'Cerrar',
        Expand   : 'Expandir'
    },

    Popup : {
        close : 'Cerrar ventana emergente'
    },

    UndoRedo : {
        Undo           : 'Deshacer',
        Redo           : 'Rehacer',
        UndoLastAction : 'Deshacer la última acción',
        RedoLastAction : 'Rehacer la última acción',
        NoActions      : 'No hay elementos en la cola de acciones'
    },

    FieldFilterPicker : {
        equals                 : 'igual a',
        doesNotEqual           : 'no es igual a',
        isEmpty                : 'está vacío',
        isNotEmpty             : 'no está vacío',
        contains               : 'contiene',
        doesNotContain         : 'no contiene',
        startsWith             : 'empieza con',
        endsWith               : 'termina con',
        isOneOf                : 'es uno de',
        isNotOneOf             : 'no es uno de',
        isGreaterThan          : 'es mayor que',
        isLessThan             : 'es menor que',
        isGreaterThanOrEqualTo : 'es mayor o igual que',
        isLessThanOrEqualTo    : 'es menor o igual que',
        isBetween              : 'está entre',
        isNotBetween           : 'no está entre',
        isBefore               : 'está antes de',
        isAfter                : 'está después de',
        isToday                : 'es hoy',
        isTomorrow             : 'es mañana',
        isYesterday            : 'era ayer',
        isThisWeek             : 'es esta semana',
        isNextWeek             : 'es la próxima semana',
        isLastWeek             : 'era la semana pasada',
        isThisMonth            : 'es este mes',
        isNextMonth            : 'es el próximo mes',
        isLastMonth            : 'era el mes pasado',
        isThisYear             : 'es este año',
        isNextYear             : 'es el próximo año',
        isLastYear             : 'era el año pasado',
        isYearToDate           : 'es el año hasta la fecha',
        isTrue                 : 'es verdadero',
        isFalse                : 'es falso',
        selectAProperty        : 'Seleccione una propiedad',
        selectAnOperator       : 'Seleccione un operador',
        caseSensitive          : 'Distinguir mayúsculas/minúsculas',
        and                    : 'y',
        dateFormat             : 'D/M/YY',
        selectValue            : 'Seleccione un valor',
        selectOneOrMoreValues  : 'Seleccione uno o más valores',
        enterAValue            : 'Introduzca un valor',
        enterANumber           : 'Introduzca un número',
        selectADate            : 'Seleccione una fecha',
        selectATime            : 'Seleccione una hora'
    },

    FieldFilterPickerGroup : {
        addFilter : 'Agregar filtro'
    },

    DateHelper : {
        locale         : 'es',
        weekStartDay   : 1,
        nonWorkingDays : {
            0 : true,
            6 : true
        },
        weekends : {
            0 : true,
            6 : true
        },
        unitNames : [
            { single : 'milisegundo', plural : 'ms', abbrev : 'ms' },
            { single : 'emilisegundo', plural : 'ems', abbrev : 'ems' },
            { single : 'segundo', plural : 'segundos', abbrev : 's' },
            { single : 'esegundo', plural : 'esegundos', abbrev : 'es' },
            { single : 'minuto', plural : 'minutos', abbrev : 'min' },
            { single : 'eminuto', plural : 'eminutos', abbrev : 'emin' },
            { single : 'hora', plural : 'horas', abbrev : 'h' },
            { single : 'ehora', plural : 'ehoras', abbrev : 'eh' },
            { single : 'día', plural : 'días', abbrev : 'd' },
            { single : 'edía', plural : 'edías', abbrev : 'ed' },
            { single : 'semana', plural : 'semanas', abbrev : 'sem' },
            { single : 'esemana', plural : 'esemanas', abbrev : 'esem' },
            { single : 'mes', plural : 'meses', abbrev : 'mes' },
            { single : 'emes', plural : 'emeses', abbrev : 'emes' },
            { single : 'trimestre', plural : 'trimestres', abbrev : 'trim' },
            { single : 'etrimestre', plural : 'etrimestres', abbrev : 'etrim' },
            { single : 'año', plural : 'años', abbrev : 'a' },
            { single : 'eaño', plural : 'eaños', abbrev : 'ea' },
            { single : 'década', plural : 'décadas', abbrev : 'dec' },
            { single : 'edécada', plural : 'edécadas', abbrev : 'edec' }
        ],
        unitAbbreviations : [
            ['mil'],
            ['emil'],
            ['s', 'seg'],
            ['es', 'eseg'],
            ['m', 'min'],
            ['em', 'emin'],
            ['h', 'hr'],
            ['eh', 'ehr'],
            ['d'],
            ['ed'],
            ['sem', 'seman'],
            ['esem', 'eseman'],
            ['m', 'mes'],
            ['em', 'emes'],
            ['t', 'trim', 'trmt'],
            ['et', 'etrim', 'etrmt'],
            ['a', 'año'],
            ['ea', 'eaño'],
            ['dec'],
            ['edec']
        ],
        parsers : {
            L   : 'DD/MM/YYYY',
            LT  : 'HH:mm',
            LTS : 'HH:mm:ss A'
        },
        ordinalSuffix : number => {
            return number + '°';
        }
    }
}

export default locale
